import {createSvgIcon} from '../create-svg-icon';

export const MaximizeIcon = createSvgIcon(
  <path d="M3 3h18v2H3V3z" />
, 'MaximizeOutlined');
